import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Banner from "@/components/banner/Banner.vue";
import store from "@/store";
import { AUTH_LINK_AUTH_GENERATE, AUTH_LINK_WITH_AUTHITEM } from "@/store/actions/authLink";
var AuthLinkConnect = /*#__PURE__*/function (_Vue) {
  function AuthLinkConnect() {
    var _this;
    _classCallCheck(this, AuthLinkConnect);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AuthLinkConnect, [].concat(args));
    _defineProperty(_this, "authItemID", void 0);
    _defineProperty(_this, "asc", void 0);
    _defineProperty(_this, "token", void 0);
    _defineProperty(_this, "originalPlatform", void 0);
    _defineProperty(_this, "loading", true);
    _defineProperty(_this, "errorMsg", '');
    return _this;
  }
  _inherits(AuthLinkConnect, _Vue);
  return _createClass(AuthLinkConnect, [{
    key: "mounted",
    value: function mounted() {
      this.loadPublicAuthLink();
    }
  }, {
    key: "redirectMessage",
    get: function get() {
      return this.originalPlatform ? 'Connection to ' + this.originalPlatform : '';
    }
  }, {
    key: "authLink",
    get: function get() {
      var _Object$values,
        _this2 = this;
      return (_Object$values = Object.values(this.linkList)) === null || _Object$values === void 0 ? void 0 : _Object$values.find(function (link) {
        return link.platform.url === _this2.originalPlatform;
      });
    }
    /**
     * Get the list of other available platforms for the current user
     * format = "name1:url1,name2:url2,name3:url3..."
     */
  }, {
    key: "otherPlatformsAvailable",
    get: function get() {
      var _this3 = this;
      return Object.values(this.linkList).reduce(function (accumulator, link) {
        if (link.platform.platformID !== _this3.authLink.platform.platformID) {
          accumulator.push(link.platform.name + ':' + link.platform.url);
        }
        return accumulator;
      }, []).toString();
    }
  }, {
    key: "linkList",
    get: function get() {
      return store.getters.authLinks;
    }
  }, {
    key: "loadPublicAuthLink",
    value: function loadPublicAuthLink() {
      var _this4 = this;
      // we load the list of cluster
      store.dispatch(AUTH_LINK_WITH_AUTHITEM, {
        authItemId: this.authItemID,
        token: this.token
      }).then(function () {
        _this4.goToPlatform();
      }).catch(function (err) {
        _this4.loading = false;
        _this4.errorMsg = err;
      });
    }
  }, {
    key: "goToPlatform",
    value: function () {
      var _goToPlatform = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this5 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // have to regenerate a token because we receive an enterprise suite token
              store.dispatch(AUTH_LINK_AUTH_GENERATE, {
                token: this.token,
                authLinkID: this.authLink.authLinkID
              }).then(function (tokenToSend) {
                var form = _this5.$refs.formPost;
                var token = _this5.$refs.tokenToSend;
                token.value = tokenToSend; // we don't use v-model for the token, to avoid rendering time
                form.submit();
              }).catch(function (err) {
                _this5.loading = false;
                _this5.errorMsg = err;
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function goToPlatform() {
        return _goToPlatform.apply(this, arguments);
      }
      return goToPlatform;
    }()
  }]);
}(Vue);
__decorate([Prop()], AuthLinkConnect.prototype, "authItemID", void 0);
__decorate([Prop()], AuthLinkConnect.prototype, "asc", void 0);
__decorate([Prop()], AuthLinkConnect.prototype, "token", void 0);
__decorate([Prop()], AuthLinkConnect.prototype, "originalPlatform", void 0);
AuthLinkConnect = __decorate([Options({
  components: {
    Banner: Banner
  }
})], AuthLinkConnect);
export default AuthLinkConnect;